export default "assets/images/icons/email-f9c9aad1.svg";